export default __webpack_public_path__ + "static/media/color.1f4af7d3.svg";